import React, { useEffect, useState } from 'react';
import { Navigate, useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux/es/hooks/useSelector';
import { shallowEqual } from 'react-redux';
import installationService from '../services/installation';
import Loading from '../components/loading';

export const WelcomeLayout = ({ children }) => {
  const { user } = useSelector((state) => state.auth, shallowEqual);
  const menuActive = useSelector((list) => list.menu.activeMenu, shallowEqual);
  const navigate = useNavigate();
  const location = useLocation();

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    installationService
      .checkInitFile()
      .then(() => navigate('/'))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    <Loading />;
  }

  if (user) {
    // If menuActive is default dashboard, redirect to dashboard
    // Otherwise, redirect to menuActive URL
    const isDefaultDashboard =
      menuActive?.url === 'dashboard' && menuActive?.id === 1;
    if (isDefaultDashboard || !menuActive) {
      return <Navigate to='/dashboard' replace />;
    }
    return <Navigate to={`/${menuActive.url}`} replace />;
  }

  return children;
};
